// src/pages/Dashboard/components/ChatPanel/ChatPanel.js - CORRIGIDO

import React from 'react';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';  // ✅ CORREÇÃO: Import correto (plural)
import ChatInput from './ChatInput';
import './ChatPanel.css';

/**
 * Painel direito do chat (70%)
 * @param {Array} models - Lista de modelos
 * @param {object} selectedModel - Modelo selecionado
 * @param {Array} messages - Lista de mensagens
 * @param {string} inputMessage - Valor do input
 * @param {boolean} isLoading - Se está carregando
 * @param {object} messagesEndRef - Ref para scroll
 * @param {function} onSelectModel - Callback para selecionar modelo
 * @param {function} onUpdateInput - Callback para atualizar input
 * @param {function} onSendMessage - Callback para enviar mensagem
 */
const ChatPanel = ({
  models,
  selectedModel,
  messages,
  inputMessage,
  isLoading,
  messagesEndRef,
  onSelectModel,
  onUpdateInput,
  onSendMessage
}) => {
  return (
    <div className="dashboard-right">
      <ChatHeader
        models={models}
        selectedModel={selectedModel}
        onChangeModel={onSelectModel}
      />
      
      <ChatMessages
        messages={messages}
        isLoading={isLoading}
        messagesEndRef={messagesEndRef}
      />
      
      <ChatInput
        value={inputMessage}
        onChange={onUpdateInput}
        onSend={onSendMessage}
        disabled={isLoading}
      />
    </div>
  );
};

export default ChatPanel;